export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "click_to_scan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to scan code"])}
    }
  })
}
